'use client'
import { Skeleton } from '@mantine/core'

// Mirrors PropertyCard's ishome layout element for element, so the swap from
// skeleton to card causes no reflow. Keep in sync with PropertyCard and
// PropertyCardParts.
const PropertyCardSkeleton = ({ width = 'max-w-[290px]', loading }) => {
  return (
    <div className={`w-full sm:w-1/2 md:w-1/4 p-2 box-border ${width}`}>
      <div className='w-full h-full flex flex-col'>
        {/* PropertyImageSection */}
        <div className='w-full aspect-square rounded-[20px] overflow-hidden bg-gray-200'>
          <Skeleton visible={loading} height='100%' width='100%' />
        </div>

        <div className='flex flex-1 flex-col mt-3 gap-2'>
          {/* Name — line-clamp-2 in a min-h-[44px] box */}
          <div className='min-h-[44px] flex flex-col gap-2'>
            <Skeleton width='90%' height={16} visible={loading} />
            <Skeleton width='65%' height={16} visible={loading} />
          </div>

          {/* PropertyLocation + HomePropertyReviews pill */}
          <div className='flex items-center justify-between gap-2'>
            <div className='flex items-center gap-1'>
              <Skeleton width={16} height={16} visible={loading} />
              <Skeleton width={72} height={12} visible={loading} />
            </div>
            <Skeleton width={52} height={22} radius={999} visible={loading} />
          </div>

          {/* PropertyUnitFacts — icon + label per fact */}
          <div className='flex items-center gap-3 h-[18px]'>
            <div className='flex items-center gap-1'>
              <Skeleton width={14} height={14} visible={loading} />
              <Skeleton width={58} height={12} visible={loading} />
            </div>
            <div className='flex items-center gap-1'>
              <Skeleton width={14} height={14} visible={loading} />
              <Skeleton width={42} height={12} visible={loading} />
            </div>
            <div className='flex items-center gap-1'>
              <Skeleton width={14} height={14} visible={loading} />
              <Skeleton width={48} height={12} visible={loading} />
            </div>
          </div>

          {/* HomePriceSection */}
          <div className='flex items-center justify-between gap-2 mt-auto pt-1'>
            <Skeleton width={110} height={16} visible={loading} />
            <Skeleton width={62} height={26} radius={999} visible={loading} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default PropertyCardSkeleton
